import src from "IMAGE";
export default { src, width: 470, height: 413, blurWidth: 0, blurHeight: 0};
